module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/banner--procedures-5e3c04cf81e89be56e562c0036b93277.jpg";